/* eslint-disable max-len */
export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    setAttribute(context, `${moduleId}`, 'contact', apiData.contact);
    setAttribute(context, `${moduleId}`, 'fileUploads', apiData['confirmation.fileUploads']);
    setAttribute(context, `${moduleId}`, 'load', false);
};